<template>
<svg :width="width" :height="height" viewBox="0 0 26 20" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M0 3.42857C0 2.324 0.895431 1.42857 2 1.42857H10.2333C10.6247 1.42857 11.0075 1.31374 11.3343 1.0983L12.4991 0.330275C12.8258 0.114835 13.2086 0 13.6 0H24C25.1046 0 26 0.895431 26 2V16.5714C26 17.676 25.1046 18.5714 24 18.5714H15.7667C15.3753 18.5714 14.9925 18.6863 14.6657 18.9017L13.5009 19.6697C13.1742 19.8852 12.7914 20 12.4 20H2C0.89543 20 0 19.1046 0 18V3.42857Z" />
<circle cx="13" cy="10" r="5" fill="white"/>
<circle cx="13" cy="10" r="4" />
<circle cx="22" cy="4" r="1" fill="white"/>
</svg>

</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 26 },
        height: { type: [Number, String], default: 20 },
        color: { type: String, default: "#D3D4DE" }
    }
}
</script>
